// /directorio-hoteles — SSR head() for the hotel directory index.
import { createFileRoute } from "@tanstack/react-router";
import HotelDirectory from "@/pages/HotelDirectory";
import { buildStaticHead, staticLoader, type StaticSEO } from "@/lib/static-route-seo";

const SEO: StaticSEO = {
  es: {
    title: "Directorio de Hoteles en Brasil | Fora da Rota",
    description:
      "Explora el directorio completo de hoteles y resorts en Brasil. Encuentra opciones por destino, categoría y régimen.",
  },
  "pt-BR": {
    title: "Diretório de Hotéis no Brasil | Fora da Rota",
    description:
      "Explore o diretório completo de hotéis e resorts no Brasil. Encontre opções por destino, categoria e regime.",
  },
  en: {
    title: "Hotels Directory in Brazil | Fora da Rota",
    description:
      "Browse the full directory of hotels and resorts in Brazil. Filter by destination, category and board plan.",
  },
  "en-EU": {
    title: "Hotels Directory in Brazil | Fora da Rota",
    description:
      "Browse the full directory of hotels and resorts in Brazil. Filter by destination, category and board plan.",
  },
};

export const Route = createFileRoute("/directorio-hoteles")({
  loader: staticLoader,
  head: ({ loaderData }) =>
    buildStaticHead(SEO, "/directorio-hoteles", loaderData, {
      jsonLd: (url, seo) => ({
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: seo.title,
        description: seo.description,
        url,
      }),
    }),
  component: HotelDirectory,
});
